/*
 * Size chart dialog and cm/inch conversion.
 *
 * Measurements live in the markup as centimetres only; inches are
 * computed here, so there is one source of truth and the merchant never
 * has to keep two sets of numbers in step.
 */
(function () {
  const CM_PER_INCH = 2.54;

  function toInches(cmText) {
    // Handles "76-80" and plain "76" alike, and leaves anything that is
    // not a number (a dash, "one size") untouched.
    return cmText.replace(/\d+(?:[.,]\d+)?/g, (match) => {
      const cm = parseFloat(match.replace(',', '.'));
      if (isNaN(cm)) return match;
      return String(Math.round(cm / CM_PER_INCH));
    });
  }

  function setUnits(dialog, unit) {
    dialog.querySelectorAll('td[data-cm]').forEach((cell) => {
      const cm = cell.dataset.cm;
      cell.textContent = unit === 'in' ? toInches(cm) : cm;
    });

    dialog.querySelectorAll('th[scope="col"]').forEach((header, index) => {
      // The first column is the size label, which has no unit
      if (index === 0) return;
      header.textContent = header.textContent.replace(/\((cm|in)\)/i, '(' + unit + ')');
    });
  }

  function open(dialog) {
    // showModal puts the dialog in the browser's top layer, so it escapes
    // any ancestor stacking context and ::backdrop covers the page.
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.sizeChartOpen);
      if (dialog) open(dialog);
      return;
    }

    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      const dialog = closer.closest('[data-size-chart]');
      if (dialog) dialog.close();
      return;
    }

    // Clicking the backdrop lands on the dialog element itself, since the
    // content sits in an inner wrapper.
    const dialog = event.target.closest('[data-size-chart]');
    if (dialog && event.target === dialog) dialog.close();
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-size-chart-unit]');
    if (!input) return;

    const dialog = input.closest('[data-size-chart]');
    if (dialog) setUnits(dialog, input.value);
  });
})();
